export const unavailabityReason = [
  'absence-evenement-familial',
  'absence-hospitalisation-naissance-enfant',
  'absence-injustifié',
  'accident-trajet',
  'accident-travail',
  'conge-pathologique-prenatal',
  'conge-presence-parental',
  'conge-proche-aidant',
  'conge-parental',
  'conge-paye',
  'conge-sans-solde',
  'cse',
  'ecole',
  'formation-externe',
  'formation-interne',
  'garde-enfant-malade',
  'irp',
  'maladie',
  'maladie-pro',
  'maternite',
  'paternite',
  'mise-a-pied',
  'mission-externe-deplacement',
  'recuperation',
  'repo-compensation-nuit',
  'teletravail',
  'visite-medicale',
] as const
export type UnavailabityReason = (typeof unavailabityReason)[number]

export const unavailabityReasonLabel: Record<UnavailabityReason, string> = {
  'absence-evenement-familial': 'Absence événement familial',
  'absence-hospitalisation-naissance-enfant': 'Absence hospitalisation naissance enfant',
  'absence-injustifié': 'Absence injustifiée',
  'accident-trajet': 'Accident trajet',
  'accident-travail': 'Accident travail',
  'conge-pathologique-prenatal': 'Congé pathologique prénatal',
  'conge-presence-parental': 'Congé parental',
  'conge-proche-aidant': 'Congé proche aidant',
  'conge-parental': 'Congé parental',
  'conge-paye': 'Congé payé',
  'conge-sans-solde': 'Congé sans solde',
  cse: 'CSE',
  ecole: 'Ecole',
  'formation-externe': 'Formation externe',
  'formation-interne': 'Formation interne',
  'garde-enfant-malade': 'Gardes enfant malade',
  irp: 'IRP',
  maladie: 'Maladie',
  'maladie-pro': 'Maladie professionnelle',
  maternite: 'Maternité',
  paternite: 'Paternité',
  'mise-a-pied': 'Mise à pied',
  'mission-externe-deplacement': 'Mission externe déplacement',
  recuperation: 'Recuperation',
  'repo-compensation-nuit': 'Répo compensation nuit',
  teletravail: 'Télétravail',
  'visite-medicale': 'Visite médicale',
}
